import MobileUploadItem from './MobileUploadItem'
export default MobileUploadItem
